<mat-tab-group [(selectedIndex)]="selectedIndex">
    <mat-tab [disabled]="!quote_tab">
        <ng-template mat-tab-label>
            Quote
        </ng-template>
        <div class="card-body">
            <app-admin-al-indicative-quote [quoteDetails]="quoteDetailsForChildTemplates"
            [allbrokers]="brokers" [allPolicyReasons]="allPolicyReasons"
            (quoteDetailsUpdated)="quoteDetailsUpdated($event)"
            (ProceedWithQuoteBtn)="activateIndicativeQuoteDetailsPage()"></app-admin-al-indicative-quote>
        </div>
    </mat-tab>
    <mat-tab *ngIf='QuoteDetailsPage' [disabled]="!quote_details_tab">
        <ng-template mat-tab-label>
            Quote Other Details
        </ng-template>
        <div class="card-body">
            <app-admin-al-indicative-quote-details [quoteDetails]="quoteDetailsForChildTemplates"
            [allbrokers]="brokers" [allPolicyReasons]="allPolicyReasons"
            (quoteDetailsUpdated)="quoteDetailsUpdated($event)"
            (BackToIndicativeQuote)="activateIndicativeQuoteTab()"
            (ProceedWithFullDetails)="activateFullDetailsTab()" [staticData]="staticData"></app-admin-al-indicative-quote-details>
        </div>
    </mat-tab> 
    <mat-tab [disabled]="!full_details_tab">
         <ng-template mat-tab-label>
            Full Details
        </ng-template>
        <div class="card-body">
            <app-admin-al-full-details [quoteDetails]="quoteDetailsForChildTemplates"
            [allbrokers]="brokers" [allPolicyReasons]="allPolicyReasons"
            (quoteDetailsUpdated)="quoteDetailsUpdated($event)"
            (BackToQuoteDetails)="activateIndicativeQuoteDetailsPage()"
            (ProceedWithSOFDetails)="activateSOFTab()" [staticData]="staticData"></app-admin-al-full-details>
        </div>
    </mat-tab>
    <mat-tab [disabled]="!statement_of_facts_tab">
        <ng-template mat-tab-label>
            Statement Of Fact
        </ng-template>
        <div class="card-body">
            <app-admin-al-sof [quoteDetails]="quoteDetailsForChildTemplates"
            (quoteDetailsUpdated)="quoteDetailsUpdated($event)"
            (BackToFullDetails)="activateFullDetailsTab()"
            (proceedToQuotationTab)="activateQuotationTab()"></app-admin-al-sof>
        </div>
    </mat-tab>

    <mat-tab [disabled]="!quotation_tab">
        <ng-template mat-tab-label>
            Quotation Details
        </ng-template>
        <div class="card-body">
            <app-admin-al-quotation [quoteDetails]="quoteDetailsForChildTemplates"
            (quoteDetailsUpdated)="quoteDetailsUpdated($event)"
            [selectedIndex]="selectedIndex"
             (BackToSOFDetails)="activateSOFTab()" [staticData]="staticData"
            (proceedToPayment)="activatePolicyPaymentTab()"></app-admin-al-quotation>
        </div>
    </mat-tab>
    <mat-tab [disabled]="!polciy_payment_tab">
        <ng-template mat-tab-label>
            Policy & Payment Details
        </ng-template>
        <div class="card-body">
            <app-admin-al-policy-and-payment [quoteDetails]="quoteDetailsForChildTemplates"
            [selectedIndex]="selectedIndex"
            (quoteDetailsUpdated)="quoteDetailsUpdated($event)"
             (BackToQuotationTab)="activateQuotationTab()"></app-admin-al-policy-and-payment>
        </div>
    </mat-tab>
</mat-tab-group>